
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpurcabs() {



    const cardData =
    {
        keyword: 'Pune to Pandharpur Cabs',
        heading: 'Platinum24 Cabs: Pune to Pandharpur Cabs',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Pandharpur Cabs, ideal for devotees visiting the sacred Vitthal-Rukmini Temple or travelers heading to this holy town for spiritual experiences. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride with spacious seating and smooth air-conditioned travel. With professional chauffeurs familiar with the Pune–Pandharpur route, we guarantee punctual pickups, convenient halts, and a stress-free journey. Whether it’s for Pandharpur Wari, a family yatra, or a weekend pilgrimage, Platinum24 Cabs provides affordable fares, transparent pricing, and dependable service every time.',

        top: 'Top Places to Visit in Pandharpur with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Temple",
    "description": "The Vitthal Rukmini Temple is the spiritual heart of Pandharpur, dedicated to Lord Vithoba and Goddess Rukmini. Considered the ‘Kashi of the South,’ it attracts millions of devotees every year. Pilgrims believe that darshan here fulfills wishes and grants peace. The temple’s black stone idol of Vithoba standing on a brick is iconic in Maharashtra’s Bhakti tradition. Festivals like Ashadhi Ekadashi and Kartiki Ekadashi bring lakhs of warkaris on foot pilgrimages. The temple is Pandharpur’s divine center of faith and devotion."
  },
  {
    "title": "Chandrabhaga River (Bhima River)",
    "description": "The Chandrabhaga River, also called Bhima, flows gracefully through Pandharpur in a crescent moon shape. Pilgrims take holy dips here before visiting the Vitthal Temple, believing it washes away sins. During Ekadashi yatras, thousands bathe in its waters creating a divine aura. The ghats are lined with devotional chants, bhajans, and rituals. Scenic views of the river at sunrise and sunset are enchanting. Chandrabhaga is Pandharpur’s sacred river of purification."
  },
  {
    "title": "Pundalik Temple",
    "description": "The Pundalik Temple is dedicated to Saint Pundalik, whose devotion to his parents brought Lord Vitthal to Pandharpur. Legend says Vithoba stood on a brick waiting for Pundalik, which led to the establishment of the temple. Pilgrims offer prayers here before visiting the main Vitthal Temple. The temple radiates the spirit of selfless service and devotion. It forms the foundation of Pandharpur’s sacred history. Pundalik Temple is Pandharpur’s shrine of true bhakti."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "Kaikadi Maharaj Math is a unique pilgrimage spot in Pandharpur that visually narrates stories from Hindu epics. The math has underground chambers with statues depicting Ramayana, Mahabharata, and other tales. Visitors walk through life-size displays of gods, demons, and sages. It is both devotional and educational, especially for children. The math also hosts kirtans and spiritual discourses. Kaikadi Maharaj Math is Pandharpur’s temple of storytelling devotion."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "ISKCON Pandharpur, situated near the river, is a beautiful temple dedicated to Lord Krishna and Radha. The temple hosts daily aartis, kirtans, and prasadam services. The architecture blends modern and traditional styles, with colorful deities and peaceful gardens. Devotees also engage in community service and educational activities here. It is a serene place for meditation and bhakti. ISKCON is Pandharpur’s international center of Krishna devotion."
  },
  {
    "title": "Gopalpur",
    "description": "Gopalpur, located 5 km from Pandharpur, is associated with the holy stay of Lord Vithoba and Rukmini. Pilgrims believe the divine couple visited this place, making it sacred. The small temple and ghats here are peaceful, away from the crowds. The serene surroundings attract devotees seeking meditation and solitude. It is also a picnic spot for families. Gopalpur is Pandharpur’s nearby divine retreat."
  },
  {
    "title": "Sant Namdev Payari",
    "description": "Sant Namdev Payari (steps) is located at the entrance of the Vitthal Temple. It is believed that Sant Namdev sang kirtans here, and Lord Vitthal blessed him. Devotees touch and bow to these steps before entering the temple. The site reflects the deep Bhakti tradition of Varkaris. It connects visitors to the legacy of saints like Tukaram, Namdev, and Dnyaneshwar. Sant Namdev Payari is Pandharpur’s symbol of saintly devotion."
  },
  {
    "title": "Dindi Procession Route",
    "description": "The Dindi Procession Route in Pandharpur comes alive during the grand Ashadhi and Kartiki Ekadashi yatras. Thousands of Warkaris walk with palkhis (palanquins) of saints like Sant Tukaram and Sant Dnyaneshwar. Devotees sing abhangas, play traditional instruments, and dance in devotion. The procession fills the streets with spiritual energy. For pilgrims, witnessing the Dindi is a once-in-a-lifetime experience. It is Pandharpur’s living tradition of Bhakti movement."
  },
  {
    "title": "Vishnupad Temple",
    "description": "The Vishnupad Temple is believed to house Lord Vishnu’s footprints, making it sacred to devotees. Pilgrims visit to offer prayers and seek blessings for prosperity. The temple’s simple architecture adds to its spiritual aura. It is less crowded compared to the Vitthal Temple, offering peace. Rituals here are linked to Vishnu worship in Pandharpur’s tradition. Vishnupad Temple is Pandharpur’s hidden spiritual treasure."
  },
  {
    "title": "Audumbar Datta Temple",
    "description": "Located near Pandharpur, the Audumbar Temple is dedicated to Lord Dattatreya. It is believed that Lord Datta appeared here to bless devotees. Pilgrims combine visits to Pandharpur with darshan at this temple. Surrounded by riverbanks and greenery, it is a serene place for meditation. The temple reflects the Datta Sampradaya’s rich traditions. Audumbar is Pandharpur’s nearby divine extension of spirituality."
  }
],



      "services": [
    {
      "name": "Pune to Pandharpur Taxi Service",
      "description": "Reliable and comfortable taxi services from Pune to Pandharpur, perfect for pilgrims and tourists visiting the famous Vitthal Temple. Our service offers timely pickups, well-maintained vehicles, and experienced drivers ensuring a safe and smooth journey for your spiritual trip."
    },
    {
      "name": "Pandharpur Cab from Pune",
      "description": "Affordable cab options from Pune to Pandharpur, including sedans, SUVs, and tempo travellers for individual travelers and groups. Enjoy hassle-free bookings, clean cars, and friendly drivers who are knowledgeable about local routes and pilgrimage needs."
    },
    {
      "name": "Pune Pandharpur Taxi Booking",
      "description": "Book your taxi from Pune to Pandharpur easily via our online platform or customer support. Receive instant confirmation, transparent pricing, and a range of vehicle options suitable for your travel preferences."
    },
    {
      "name": "Taxi for Pandharpur Pilgrimage Pune",
      "description": "Specialized pilgrimage taxi services from Pune to Pandharpur tailored to devotees. Comfortable and reliable rides to ensure timely arrival at the Vitthal Temple and a hassle-free spiritual journey."
    },
    {
      "name": "Pune to Pandharpur Car Rental",
      "description": "Flexible car rental services from Pune to Pandharpur, offering both self-drive and chauffeur-driven options. Ideal for travelers who want to explore Pandharpur and surrounding areas at their own pace."
    },
    {
      "name": "Pandharpur Taxi Packages Pune",
      "description": "Comprehensive taxi packages for Pune to Pandharpur journeys including fuel, tolls, and driver allowances. Choose from hourly, daily, or customized packages that best suit your pilgrimage or sightseeing plans."
    },
    {
      "name": "Affordable Cab Pune to Pandharpur",
      "description": "Budget-friendly cab services from Pune to Pandharpur providing comfort and reliability without compromising on quality. Perfect for travelers looking for economical travel options."
    },
    {
      "name": "Pune Pandharpur Private Taxi",
      "description": "Exclusive private taxi service from Pune to Pandharpur, offering privacy, flexible timings, and personalized routes. Ideal for families, groups, or corporate travelers seeking a tailored travel experience."
    },
    {
      "name": "Pune to Pandharpur Taxi Fare",
      "description": "Transparent and competitive taxi fare details for routes between Pune and Pandharpur. Get clear fare estimates based on vehicle type, trip duration, and travel dates for effective budget planning."
    },
    {
      "name": "Pandharpur Cab Charges Pune",
      "description": "Detailed information on cab charges from Pune to Pandharpur including all applicable costs such as fuel, tolls, and driver allowances, enabling travelers to make informed decisions."
    },
    {
      "name": "Pune to Pandharpur Taxi Hire",
      "description": "Flexible taxi hire options from Pune to Pandharpur available for short or extended durations. Whether a one-way trip or a full-day tour, our services provide reliable vehicles and professional drivers."
    },
    {
      "name": "Pandharpur Temple Taxi Service Pune",
      "description": "Dedicated taxi services catering to devotees visiting the Vitthal Temple in Pandharpur, ensuring timely pickups, comfortable rides, and experienced drivers familiar with the pilgrimage route."
    },
    {
      "name": "Pune to Pandharpur One Way Cab",
      "description": "Affordable one-way cab services from Pune to Pandharpur, ideal for travelers seeking point-to-point transport without the need for a return journey. Hassle-free bookings and professional service guaranteed."
    },
    {
      "name": "Pune Pandharpur Taxi with Driver",
      "description": "Professional and courteous drivers accompany every Pune to Pandharpur taxi booking to ensure a safe and comfortable journey. Drivers are well-acquainted with the best routes and local customs."
    },
    {
      "name": "Taxi Service Pune to Pandharpur",
      "description": "Comprehensive taxi service options available 24/7 from Pune to Pandharpur, suitable for local transfers, pilgrimage tours, and leisure trips. Expect timely pickups, clean vehicles, and excellent customer support."
    }
  ],
  "tableData": [
    ["Pune to Pandharpur Taxi Service", "Pandharpur Cab from Pune"],
    ["Pune Pandharpur Taxi Booking", "Taxi for Pandharpur Pilgrimage Pune"],
    ["Pune to Pandharpur Car Rental", "Pandharpur Taxi Packages Pune"],
    ["Affordable Cab Pune to Pandharpur", "Pune Pandharpur Private Taxi"],
    ["Pune to Pandharpur Taxi Fare", "Pandharpur Cab Charges Pune"],
    ["Pune to Pandharpur Taxi Hire", "Pandharpur Temple Taxi Service Pune"],
    ["Pune to Pandharpur One Way Cab", "Pune Pandharpur Taxi with Driver"],
    ["Taxi Service Pune to Pandharpur", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Pandharpur Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and dependable cab rides from Pune to Pandharpur for a smooth journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Pandharpur Routes",
      "WhyChoosedescription": "Our professional drivers know the best routes to ensure safe and timely travel."
    },
    {
      "WhyChooseheading": "Spacious and Clean Vehicles for Long-Distance Travel",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for your comfort."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages that fit your itinerary and travel plans."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing including fuel, tolls, and driver allowances for a hassle-free ride."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Convenient Booking",
      "WhyChoosedescription": "Our team is available around the clock to assist you with bookings and inquiries."
    },
    {
      "WhyChooseheading": "Ideal for Family, Group, and Pilgrimage Trips",
      "WhyChoosedescription": "Our cabs accommodate all types of travelers for leisure or spiritual journeys."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, or SUVs based on group size and luggage."
    }
  ]

































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Pandharpur?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Pandharpur.',
    },
    {
        question: 'How can I book a Pune to Pandharpur cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Pandharpur cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Pandharpur trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Pandharpur?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Pandharpur route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Pandharpur?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Pandharpur cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Pandharpur rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Pandharpur route.',
    },
    {
        question: 'Are safety measures in place for Pune to Pandharpur cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Pandharpur travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Pandharpur?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Pandharpur routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Manoj Deshmukh',
        feedback: 'The Pune to Pandharpur cab service by Platinum24 Cabs was excellent. The driver was punctual and the vehicle was comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'I had a great trip to Pandharpur with Platinum24 Cabs. The booking was simple and the service was top-notch.',
        rating: 5,
    },
];










































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToPandharpurCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-pandharpur-cab.jpg",
  "description": "Book Pune to Pandharpur cab service with Platinum24 Cabs. Comfortable AC taxis, private cars, and tempo travellers for Pandharpur Vitthal Temple pilgrimage. One-way, round trip, and group cab packages available.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-pandharpur-cabs"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Pandharpur Cabs | Vitthal Mandir Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Pandharpur cab with Platinum24 Cabs. AC taxis, private cars & group cabs available for Vitthal Mandir pilgrimage. Safe travel with verified drivers and 24/7 support."
  />
  <meta
    name="keywords"
    content="Pune to Pandharpur Taxi Service, Pandharpur Cab from Pune, Pune Pandharpur Taxi Booking, Taxi for Pandharpur Pilgrimage Pune, Pune to Pandharpur Car Rental, Pandharpur Taxi Packages Pune, Affordable Cab Pune to Pandharpur, Pune Pandharpur Private Taxi, Pune to Pandharpur Taxi Fare, Pandharpur Cab Charges Pune, Pune to Pandharpur Taxi Hire, Pandharpur Temple Taxi Service Pune, Pune to Pandharpur One Way Cab, Pune Pandharpur Taxi with Driver, Taxi Service Pune to Pandharpur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToPandharpurCabsSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopandharpurcabs;